export const FILTER_BY_OPTIONS = [
    {
        text: 'All',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: '',
        key: 0
    },{
        text: 'Created by Me',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'creator',
        key: 1
    },{
        text: 'Beacons',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'uuid',
        key: 2
    },{
        text: 'Geofences',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'gps',
        key: 3
    }
];

export const SORT_BY_OPTIONS = [
    {
        text: 'Recently Edited',
        sortBy: 'modified',
        sortDirection: true,
        key: 0
    },{
        text: 'Name (a-z)',
        sortBy: 'name',
        sortDirection: false,
        key: 1
    },{
        text: 'Name (z-a)',
        sortBy: 'name',
        sortDirection: true,
        key: 2
    }
];



// WEBPACK FOOTER //
// ./src/containers/PinpointsPage/constants.js